export default "__VITE_ASSET__17b68b78__"